// extracted by mini-css-extract-plugin
export default {"LandingPage":"LandingPage_LandingPage__OjxHd"};